import React from 'react';

import Loader from '../containers/loaderContainer';
import Snackbar from '../containers/snackbarContainer';
import LandingPageContainer from '../containers/rootContainer';

// import 'sanitize.css/sanitize.css';
const App = () => {
    return (
        <>
            <Loader />
            <Snackbar />
            <LandingPageContainer />
        </>
    )
}

export default App;
